(() => {
  'use strict';
  if (window.__sqSearchProductBeltReadyV6) return;
  window.__sqSearchProductBeltReadyV6 = true;
  window.__sqSearchProductBeltReadyV5 = true;
  window.__sqSearchProductBeltReadyV4 = true;
  window.__sqSearchProductBeltReadyV3 = true;
  window.__sqSearchProductBeltReadyV2 = true;
  window.__sqSearchProductBeltReady = true;

  const source = document.currentScript?.src;
  if (source) {
    const memoryCss = new URL('sq-search-memory-v1.css', source).href;
    const memoryJs = new URL('sq-search-memory-v1.js', source).href;
    if (!document.querySelector('link[data-sq-search-memory-v1]')) {
      const link = document.createElement('link'); link.rel = 'stylesheet'; link.href = memoryCss; link.dataset.sqSearchMemoryV1 = ''; document.head.appendChild(link);
    }
    if (!document.querySelector('script[data-sq-search-memory-v1]')) {
      const script = document.createElement('script'); script.src = memoryJs; script.defer = true; script.dataset.sqSearchMemoryV1 = ''; document.head.appendChild(script);
    }
  }

  const RANDOM_RAIL = '[data-sq-randomize-on-open="trending-products"],[data-sq-randomize-on-open="curve-icons"]';
  const CARD = ':scope > .sq-search-trending-card';
  let refreshFrame = 0;
  let refreshRoot = null;

  const stepFor = (rail) => {
    const card = rail.querySelector('[data-sq-search-collection-card],.sq-search-collection-belt__card');
    if (!(card instanceof HTMLElement)) return Math.max(280, rail.clientWidth * .72);
    const css = getComputedStyle(rail), gap = parseFloat(css.columnGap || css.gap) || 12;
    return card.getBoundingClientRect().width + gap;
  };

  const bindCollectionRail = (rail) => {
    if (!(rail instanceof HTMLElement) || rail.dataset.sqCollectionDragBound === 'v4') return;
    rail.dataset.sqCollectionDragBound = 'v4'; rail.style.touchAction = 'pan-x pan-y pinch-zoom'; rail.style.scrollBehavior = 'auto';
    let drag = null, blockClickUntil = 0;

    rail.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = { id: event.pointerId, x: event.clientX, y: event.clientY, start: rail.scrollLeft, moved: false };
    }, true);
    rail.addEventListener('pointermove', (event) => {
      if (!drag || event.pointerId !== drag.id) return;
      const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
      if (!drag.moved) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 4) return;
        if (Math.abs(dx) <= Math.abs(dy) * 1.08) { drag = null; return; }
        drag.moved = true; rail.classList.add('is-dragging');
        try { rail.setPointerCapture(event.pointerId); } catch (_) {}
      }
      rail.scrollLeft = drag.start - dx;
      event.preventDefault();
    }, { passive: false });
    const finish = (event) => {
      if (!drag || event.pointerId !== drag.id) return;
      const moved = drag.moved; drag = null; rail.classList.remove('is-dragging');
      if (moved) { blockClickUntil = performance.now() + 190; event.preventDefault?.(); }
    };
    rail.addEventListener('pointerup', finish, true);
    rail.addEventListener('pointercancel', finish, true);
    rail.addEventListener('click', (event) => { if (performance.now() < blockClickUntil) { event.preventDefault(); event.stopPropagation(); } }, true);
    rail.addEventListener('dragstart', (event) => event.preventDefault());
  };

  const removeHelperCopy = (root = document) => {
    root.querySelectorAll?.('.sq-search-results__intro p,.sq-search-collection-belt__status').forEach((node) => {
      const text = String(node.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === 'Use the same universal filters here to narrow the full Serein Queen edit.' || /^Collections related to “?title:\*”? are shown first\./i.test(text)) node.remove();
    });
  };

  const randomIndex = (length) => {
    if (length <= 1) return 0;
    if (window.crypto?.getRandomValues) {
      const bucket = new Uint32Array(1);
      window.crypto.getRandomValues(bucket);
      return bucket[0] % length;
    }
    return Math.floor(Math.random() * length);
  };

  const shuffle = (input) => {
    const items = [...input];
    for (let i = items.length - 1; i > 0; i -= 1) {
      const j = randomIndex(i + 1);
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  };

  const cardKey = (card) => {
    const explicit = String(card.dataset.sqTrendingKey || '').trim();
    if (explicit) return explicit;
    const link = card.querySelector('a[href*="/products/"]');
    try {
      return decodeURIComponent(new URL(link?.href || '', location.origin).pathname.match(/\/products\/([^/?#]+)/i)?.[1] || '');
    } catch (_) {
      return String(card.getAttribute('aria-label') || '').trim();
    }
  };

  const memoryKey = (rail) => {
    const section = rail.closest('[data-sq-search-trending-source]');
    const sourceHandle = String(section?.dataset.sqSearchTrendingSource || 'default').trim() || 'default';
    return `sq-search-trending-previous:${sourceHandle}`;
  };

  const readPrevious = (rail) => {
    try {
      const value = JSON.parse(sessionStorage.getItem(memoryKey(rail)) || '[]');
      return Array.isArray(value) ? value.map(String).filter(Boolean) : [];
    } catch (_) {
      return [];
    }
  };

  const writePrevious = (rail, keys) => {
    try { sessionStorage.setItem(memoryKey(rail), JSON.stringify(keys)); } catch (_) {}
  };

  const syncProductControls = (rail) => {
    requestAnimationFrame(() => {
      try { window.SQUniversalBag?.install?.(rail); } catch (_) {}
      document.dispatchEvent(new CustomEvent('sq:favorite-controls:sync', { detail: { scope: rail } }));
      document.dispatchEvent(new CustomEvent('sq:search-trending-refreshed', { detail: { rail } }));
      document.dispatchEvent(new CustomEvent('sq:universal-bag-ready'));
    });
  };

  const refreshTrendingRail = (rail) => {
    if (!(rail instanceof HTMLElement)) return;
    const now = performance.now();
    const last = Number(rail.dataset.sqTrendingLastRefresh || 0);
    if (last && now - last < 260) return;

    const cards = [...rail.querySelectorAll(CARD)].filter((node) => node instanceof HTMLElement);
    if (cards.length < 2) return;

    const requested = Number(rail.dataset.sqTrendingVisibleCount || 24);
    const visibleCount = Math.max(1, Math.min(Number.isFinite(requested) ? requested : 24, cards.length));
    const previous = new Set(readPrevious(rail));
    const fresh = shuffle(cards.filter((card) => !previous.has(cardKey(card))));
    const recycled = shuffle(cards.filter((card) => previous.has(cardKey(card))));
    const selected = fresh.slice(0, visibleCount);

    if (selected.length < visibleCount) {
      selected.push(...recycled.slice(0, visibleCount - selected.length));
    }

    const chosen = shuffle(selected);
    const chosenSet = new Set(chosen);
    const remaining = shuffle(cards.filter((card) => !chosenSet.has(card)));

    cards.forEach((card) => { card.hidden = true; });
    chosen.forEach((card) => {
      card.hidden = false;
      rail.appendChild(card);
    });
    remaining.forEach((card) => {
      card.hidden = true;
      rail.appendChild(card);
    });

    rail.scrollLeft = 0;
    rail.dataset.sqTrendingLastRefresh = String(performance.now());
    rail.dataset.sqTrendingRefresh = String(Date.now());
    writePrevious(rail, chosen.map(cardKey).filter(Boolean));
    syncProductControls(rail);
  };

  const refreshTrendingRails = (root = document) => {
    const rails = [];
    if (root instanceof Element && root.matches?.(RANDOM_RAIL)) rails.push(root);
    root.querySelectorAll?.(RANDOM_RAIL).forEach((rail) => rails.push(rail));
    [...new Set(rails)].forEach(refreshTrendingRail);
  };

  const scheduleTrendingRefresh = (root = document) => {
    refreshRoot = root instanceof Element ? root : document;
    if (refreshFrame) return;
    refreshFrame = requestAnimationFrame(() => {
      refreshFrame = 0;
      const target = refreshRoot || document;
      refreshRoot = null;
      refreshTrendingRails(target);
    });
  };

  const bindSearchOpenShuffle = () => {
    const modal = document.getElementById('search-modal');
    const dialog = modal?.matches?.('dialog') ? modal : modal?.querySelector?.('dialog');
    if (!(dialog instanceof HTMLDialogElement) || dialog.dataset.sqCurveOpenShuffleBound === 'v6') return;
    dialog.dataset.sqCurveOpenShuffleBound = 'v6';
    let wasOpen = dialog.open;
    if (wasOpen) scheduleTrendingRefresh(dialog);
    const observer = new MutationObserver(() => {
      const open = dialog.open;
      if (open && !wasOpen) scheduleTrendingRefresh(dialog);
      wasOpen = open;
    });
    observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
  };

  const scan = (root = document) => {
    if (root instanceof Element && root.matches?.('[data-sq-search-collection-rail]')) bindCollectionRail(root);
    root.querySelectorAll?.('[data-sq-search-collection-rail]').forEach(bindCollectionRail);
    removeHelperCopy(root);
    bindSearchOpenShuffle();

    const modal = document.getElementById('search-modal');
    const dialog = modal?.matches?.('dialog') ? modal : modal?.querySelector?.('dialog');
    if (dialog instanceof HTMLDialogElement && dialog.open) {
      const rail = root instanceof Element && root.matches?.(RANDOM_RAIL) ? root : root.querySelector?.(RANDOM_RAIL);
      if (rail instanceof HTMLElement && !rail.dataset.sqTrendingRefresh) scheduleTrendingRefresh(dialog);
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-sq-search-belt-button]'); if (!button) return;
    const belt = button.closest('[data-sq-search-belt]'), rail = belt?.querySelector('[data-sq-search-belt-rail]'); if (!rail) return;
    const direction = button.dataset.sqSearchBeltButton === 'prev' ? -1 : 1;
    const amount = Math.max(rail.clientWidth * .92, 320);
    rail.scrollBy({ left: direction * amount, behavior: 'auto' });
  });

  document.addEventListener('dialog:open', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const dialog = target?.matches?.('#search-modal dialog') ? target : target?.querySelector?.('#search-modal dialog');
    if (dialog instanceof HTMLDialogElement && dialog.open) scheduleTrendingRefresh(dialog);
  }, true);

  const boot = () => {
    scan();
    new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach((node) => { if (node instanceof Element) scan(node); }))).observe(document.documentElement, { childList: true, subtree: true });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot, { once: true }) : boot();
})();
